/**
 * 全局常量定义
 */

/**
 * 台桌时间状态列表
 * 用于显示台桌的当前状态(关台/洗牌/下注/等开局/结算)
 */
export const TABLE_TIME_STATUS_LIST = [
  { label: 'msg33', id: 0 }, // 关台中(等开靴)
  { label: 'msg34', id: 1 }, // 洗牌中
  { label: 'msg37', id: 2 }, // 下注中
  { label: 'msg35', id: 3 }, // 等开局
  { label: 'msg36', id: 4 }, // 结算中
] as const

/**
 * 游戏类型映射
 */
export const GAME_TYPE_MAP = {
  BJL: 'ct_bjl', // 百家乐
  JSBJL: 'ts_bjl', // 极速百家乐
  LHD: 'lh', // 龙虎斗
  SNN: 'nn', // 牛牛
  ZJH: 'zjh', // 炸金花
  GZB: 'gzb', // 干子宝
} as const

/**
 * 牛牛游戏获胜位置映射
 * key: 获胜结果ID, value: 获胜位置数组 [0=庄, 1=闲1, 2=闲2, 3=闲3]
 */
export const BULL_WIN_POSITION_MAP: Record<number, number[]> = {
  10: [0], // "庄赢"
  11: [3], // "闲3赢"
  12: [2], // "闲2赢"
  13: [2, 3], // "闲2赢闲3赢"
  14: [1], // "闲1赢"
  15: [1, 3], // "闲1赢闲3赢"
  16: [1, 2], // "闲1赢闲2赢"
  17: [1, 2, 3], // "闲1赢闲2赢闲3赢"
  21: [0], // "庄赢"
  22: [3], // "闲3赢"
  23: [2], // "闲2赢"
  24: [2, 3], // "闲2赢闲3赢"
  25: [1], // "闲1赢"
  26: [1, 3], // "闲1赢闲3赢"
  27: [1, 2], // "闲1赢闲2赢"
  28: [1, 2, 3], // "闲1赢闲2赢闲3赢"
}

/**
 * 牛牛路单结果映射
 * 将游戏结果映射到多语言文本key
 */
export const BULL_ROAD_RESULT_MAP: Record<string | number, string> = {
  A: 'msg60', // 牛牛
  a: 'msg60', // 牛牛
  0: 'msg50', // 无牛
  1: 'msg51', // 牛1
  2: 'msg52', // 牛2
  3: 'msg53', // 牛3
  4: 'msg54', // 牛4
  5: 'msg55', // 牛5
  6: 'msg56', // 牛6
  7: 'msg57', // 牛7
  8: 'msg58', // 牛8
  9: 'msg59', // 牛9
  10: 'msg60', // 牛牛
}

/**
 * 炸金花牌型花色映射
 * key: 牌型名称, value: [黑桃, 梅花, 红心, 方片] 的标识符
 */
export const GOLDEN_FLOWER_PATTERN_MAP: Record<string, string[]> = {
  // 豹子
  msg118: ['u', 'v', 'w', 'x'],
  // 同花顺
  msg117: ['q', 'r', 's', 't'],
  // 同花
  msg116: ['m', 'n', 'o', 'p'],
  // 顺子
  msg115: ['i', 'j', 'k', 'l'],
  // 对子
  msg114: ['e', 'f', 'g', 'h'],
  // 散牌
  msg113: ['a', 'b', 'c', 'd'],
}

/**
 * 扑克牌花色符号映射
 */
export const CARD_SUIT_MAP: Record<number, string> = {
  0: '♠️', // 黑桃
  1: '♣️', // 梅花
  2: '♥️', // 红心
  3: '♦️', // 方片
}

/**
 * 扑克牌点数映射
 */
export const CARD_RANK_MAP: Record<string | number, string> = {
  1: 'A',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  a: '10',
  b: 'J',
  c: 'Q',
  d: 'K',
}

/**
 * 干子宝游戏结果映射
 * value: [第一个数字, 第二个数字, 多语言文本key]
 */
export const DICE_TREASURE_RESULT_MAP: Record<number, [number, number, string]> = {
  31: [1, 2, 'gan_num'], // 干
  32: [2, 1, 'tong_num'], // 通
  33: [1, 1, 'duione_num'], // 1对
  34: [2, 2, 'duiflower_num'], // 花对
}

/**
 * 路单位置索引映射 (用于牛牛/炸金花/龙虎斗)
 * 0=庄, 1=闲1, 2=闲2, 3=闲3
 */
export const ROAD_POSITION_INDEX_MAP: Record<number, string> = {
  0: 'zhuang_num', // 庄
  1: 'xian_1_num', // 闲1
  2: 'xian_2_num', // 闲2
  3: 'xian_3_num', // 闲3
}

/**
 * 位置索引映射别名 (兼容旧代码)
 * @deprecated 使用 ROAD_POSITION_INDEX_MAP 替代
 */
export const indexMap = ROAD_POSITION_INDEX_MAP

/**
 * 游戏结果状态接口
 */
interface GameResultStatus {
  id: string // 结果ID
  label: string // 多语言文本key
  sound: string // 音效文件名
}

/**
 * 游戏结果状态列表 (百家乐/龙虎/牛牛/干子宝)
 * 用于显示游戏结果和播放对应音效
 */
export const GAME_RESULT_STATUS_LIST: GameResultStatus[] = [
  { id: '1025', label: 'msg45', sound: 'start_wager' }, // 请下注
  { id: '1026', label: 'msg70', sound: 'end_wager' }, // 停止下注
  { id: '1027', label: 'bankerWin', sound: 'banker_win' }, // 庄
  { id: '1028', label: 'playerWin', sound: 'player_win' }, // 闲
  { id: '1029', label: 'tieWin', sound: 'he' }, // 和
  { id: '1030', label: 'zhuangdui_num', sound: 'bpair_banker_win' }, // 庄对
  { id: '1031', label: 'xiandui_num', sound: 'ppair_banker_win' }, // 闲对
  { id: '1032', label: 'zhuangxiandui_num', sound: 'bppair_banker_win' }, // 庄闲对
  { id: '1039', label: 'msg45', sound: 'start_wager' }, // 请下注
  { id: '1040', label: 'dragonWin', sound: 'loong_win' }, // 龙赢
  { id: '1041', label: 'tigerWin', sound: 'tiger_win' }, // 虎赢
  { id: '10', label: 'bankerWin', sound: 'banker_win' }, // 庄赢
  { id: '11', label: 'player3Win', sound: 'bull_player3_win' }, // 闲3赢
  { id: '12', label: 'player2Win', sound: 'bull_player2_win' }, // 闲2赢
  { id: '14', label: 'player1Win', sound: 'bull_player1_win' }, // 闲1赢
  { id: '16', label: 'player12Win', sound: 'bull_player12_win' }, // 闲1赢 闲2赢
  { id: '13', label: 'player23Win', sound: 'bull_player23_win' }, // 闲2赢 闲3赢
  { id: '15', label: 'player13Win', sound: 'bull_player13_win' }, // 闲1赢 闲3赢
  { id: '17', label: 'player123Win', sound: 'bull_player123_win' }, // 闲1赢 闲2赢 闲3赢
  { id: '21', label: 'bankerWin', sound: 'banker_win' }, // 庄赢
  { id: '22', label: 'player3Win', sound: 'bull_player3_win' }, // 闲3赢
  { id: '23', label: 'player2Win', sound: 'bull_player2_win' }, // 闲2赢
  { id: '24', label: 'player23Win', sound: 'bull_player23_win' }, // 闲2赢 闲3赢
  { id: '25', label: 'player1Win', sound: 'bull_player1_win' }, // 闲1赢
  { id: '26', label: 'player13Win', sound: 'bull_player13_win' }, // 闲1赢 闲3赢
  { id: '27', label: 'player12Win', sound: 'bull_player12_win' }, // 闲1赢 闲2赢
  { id: '28', label: 'player123Win', sound: 'bull_player123_win' }, // 闲1赢 闲2赢 闲3赢
  { id: '31', label: 'DiffWin', sound: 'different_win' }, // 干赢
  { id: '32', label: 'SameWin', sound: 'different_win' }, // 通赢
  { id: '33', label: 'duione_num', sound: 'same_win_two_one' }, // 1对赢
  { id: '34', label: 'duiflower_num', sound: 'same_win_two_flowers' }, // 花对赢
]

/**
 * 游戏指令接口
 */
interface GameCommand {
  label: string // 指令名称 (多语言key)
  desc: string // 描述 (多语言key)
  value: string // 指令值
  notice?: string // 通知文本 (多语言key)
  error?: string // 错误文本 (多语言key)
  success?: string // 成功文本 (多语言key)
}

/**
 * 游戏指令列表 (换靴/换台/换荷官/暂停等)
 */
export const GAME_COMMAND_LIST: GameCommand[] = [
  {
    label: 'change_xue', // 换靴
    desc: 'change_xue_desc',
    value: '00',
    notice: 'apply_change_xue',
    error: 'msg86',
    success: 'msg170',
  },
  {
    label: 'change_change_tai', // 换台
    desc: 'change_change_tai_desc',
    value: '04',
    notice: 'apply_change_desk',
    error: 'msg92',
    success: 'msg174',
  },
  {
    label: 'change_heguan', // 换荷官
    desc: 'change_heguan_desc',
    value: '07',
    notice: 'apply_change_heguan',
    error: 'msg94',
    success: 'msg176',
  },
  {
    label: 'change_pause', // 暂停
    desc: 'change_pause_desc',
    value: '02',
    notice: 'msg89',
    error: 'msg90',
    success: 'msg172',
  },
  {
    label: 'query_money', // 查账
    desc: 'query_money_desc',
    value: '5',
  },
  {
    label: 'flying_card', // 飞牌
    desc: 'flying_card_desc',
    value: '08',
    notice: 'apply_flying_card',
    error: 'msg95',
    success: 'msg177',
  },
  {
    label: 'command_tips', // 小费
    desc: 'command_tips_desc',
    value: '03',
    notice: 'apply_tips',
    error: 'msg91',
    success: 'msg173',
  },
  {
    label: 'add_cai', // 加彩
    desc: 'add_cai_desc',
    value: '05',
    notice: 'apply_add_cai',
    error: 'msg93',
    success: 'msg175',
  },
  {
    label: 'knock_off', // 收工
    desc: 'knock_off_desc',
    value: '09',
    notice: 'apply_knock_off',
    error: 'msg96',
    success: 'msg178',
  },
]

/**
 * 视频渠道名称映射
 */
export const VIDEO_CHANNEL_MAP: Record<string, string> = {
  beadChannel: 'msg65',
  channel_1_7: 'msg66',
  channel_8_15: 'msg67',
  hallChannel_1: 'msg68',
  hallChannel_2: 'msg69',
}

/**
 * 游戏统计项配置接口
 */
interface GameStatItem {
  key: string // 统计项键名
  label: string // 多语言文本key
  color: string // 显示颜色
}

/**
 * 游戏统计配置接口
 */
interface GameStatConfig {
  items: GameStatItem[] // 统计项列表
}

/**
 * 游戏统计配置映射
 * 定义每种游戏类型的统计维度、显示文本和颜色
 */
export const GAME_STAT_CONFIG_MAP: Record<string, GameStatConfig> = {
  // 百家乐统计配置
  BJL: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'banker', label: 'zhuang_num', color: '#d92d20' }, // 庄
      { key: 'player', label: 'xian_num', color: '#095ec7' }, // 闲
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
      { key: 'bankerPair', label: 'zhuangdui_num', color: '#d92d20' }, // 庄对
      { key: 'playerPair', label: 'xiandui_num', color: '#095ec7' }, // 闲对
    ],
  },
  // 极速百家乐统计配置(与百家乐相同)
  JSBJL: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'banker', label: 'zhuang_num', color: '#d92d20' }, // 庄
      { key: 'player', label: 'xian_num', color: '#095ec7' }, // 闲
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
      { key: 'bankerPair', label: 'zhuangdui_num', color: '#d92d20' }, // 庄对
      { key: 'playerPair', label: 'xiandui_num', color: '#095ec7' }, // 闲对
    ],
  },
  // 龙虎斗统计配置
  LHD: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'dragon', label: 'zhuang_num_2', color: '#d92d20' }, // 龙
      { key: 'tiger', label: 'xian_num_2', color: '#095ec7' }, // 虎
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
    ],
  },
  // 牛牛统计配置
  SNN: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'player1', label: 'xian_1_num', color: '#095ec7' }, // 闲1赢
      { key: 'player2', label: 'xian_2_num', color: '#095ec7' }, // 闲2赢
      { key: 'player3', label: 'xian_3_num', color: '#095ec7' }, // 闲3赢
    ],
  },
  // 炸金花统计配置
  ZJH: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'player1', label: 'xian_1_num', color: '#095ec7' }, // 闲1赢
      { key: 'player2', label: 'xian_2_num', color: '#095ec7' }, // 闲2赢
      { key: 'player3', label: 'xian_3_num', color: '#095ec7' }, // 闲3赢
    ],
  },
  // 干子宝统计配置
  GZB: {
    items: [
      { key: 'total', label: 'total_num', color: '#FDC06D' }, // 总
      { key: 'diff', label: 'gan_num', color: '#d92d20' }, // 干
      { key: 'same', label: 'tong_num', color: '#095ec7' }, // 通
      { key: 'pair1', label: 'duione_num', color: '#d92d20' }, // 1对
      { key: 'pairFlower', label: 'duiflower_num', color: '#095ec7' }, // 花对
    ],
  },
}

/**
 * 游戏彩池配置映射
 * 定义每种游戏类型的实时彩池显示项
 * 与 GAME_STAT_CONFIG_MAP 不同，这里是显示下注区域的彩池金额
 */
export const GAME_POOL_CONFIG_MAP: Record<string, GameStatConfig> = {
  // 百家乐彩池配置 (与统计配置相同，去掉总)
  BJL: {
    items: [
      { key: 'banker', label: 'zhuang_num', color: '#d92d20' }, // 庄
      { key: 'player', label: 'xian_num', color: '#48c1ff' }, // 闲
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
      { key: 'bankerPair', label: 'zhuangdui_num', color: '#d92d20' }, // 庄对
      { key: 'playerPair', label: 'xiandui_num', color: '#48c1ff' }, // 闲对
    ],
  },
  // 极速百家乐彩池配置
  JSBJL: {
    items: [
      { key: 'banker', label: 'zhuang_num', color: '#d92d20' }, // 庄
      { key: 'player', label: 'xian_num', color: '#48c1ff' }, // 闲
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
      { key: 'bankerPair', label: 'zhuangdui_num', color: '#d92d20' }, // 庄对
      { key: 'playerPair', label: 'xiandui_num', color: '#48c1ff' }, // 闲对
    ],
  },
  // 龙虎斗彩池配置
  LHD: {
    items: [
      { key: 'dragon', label: 'zhuang_num_2', color: '#d92d20' }, // 龙
      { key: 'tiger', label: 'xian_num_2', color: '#48c1ff' }, // 虎
      { key: 'tie', label: 'he_num', color: '#459305' }, // 和
    ],
  },
  // 牛牛彩池配置 (6个下注区域)
  SNN: {
    items: [
      { key: 'p1_equal', label: 'p1_equal', color: '#48c1ff' }, // 闲1平
      { key: 'p1_double', label: 'p1_double', color: '#48c1ff' }, // 闲1翻
      { key: 'p2_equal', label: 'p2_equal', color: '#48c1ff' }, // 闲2平
      { key: 'p2_double', label: 'p2_double', color: '#48c1ff' }, // 闲2翻
      { key: 'p3_equal', label: 'p3_equal', color: '#48c1ff' }, // 闲3平
      { key: 'p3_double', label: 'p3_double', color: '#48c1ff' }, // 闲3翻
    ],
  },
  // 炸金花彩池配置 (与牛牛相同)
  ZJH: {
    items: [
      { key: 'p1_equal', label: 'p1_equal', color: '#48c1ff' }, // 闲1平
      { key: 'p1_double', label: 'p1_double', color: '#48c1ff' }, // 闲1翻
      { key: 'p2_equal', label: 'p2_equal', color: '#48c1ff' }, // 闲2平
      { key: 'p2_double', label: 'p2_double', color: '#48c1ff' }, // 闲2翻
      { key: 'p3_equal', label: 'p3_equal', color: '#48c1ff' }, // 闲3平
      { key: 'p3_double', label: 'p3_double', color: '#48c1ff' }, // 闲3翻
    ],
  },
  // 干子宝彩池配置
  GZB: {
    items: [
      { key: 'diff', label: 'gan_num', color: '#d92d20' }, // 干
      { key: 'same', label: 'tong_num', color: '#48c1ff' }, // 通
      { key: 'pair1', label: 'duione_num', color: '#d92d20' }, // 1对
      { key: 'pairFlower', label: 'duiflower_num', color: '#48c1ff' }, // 花对
    ],
  },
}
